import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs/modular/sortable.core.esm.js'

export default class extends Controller {
  static values = { url: String }
  static targets = ["list"]

  connect() {
    if (!this.hasListTarget) return

    this.sortable = new Sortable(this.listTarget, {
      animation: 150,
      draggable: '[data-show-id]',
      handle: '.drag-handle',
      ghostClass: 'opacity-50',
      chosenClass: 'bg-primary-50',
      onEnd: (evt) => {
        if (evt.oldIndex !== evt.newIndex) {
          this.saveOrder()
        }
      }
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async saveOrder() {
    const items = this.listTarget.querySelectorAll('[data-show-id]')
    const ids = Array.from(items)
      .map(item => `show_ids[]=${item.dataset.showId}`)
      .join('&')

    if (!ids) return

    try {
      const response = await fetch(this.urlValue, {
        method: 'PUT',
        body: ids,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`)
      }
    } catch (error) {
      console.error('Failed to save show order:', error)
    }
  }
}
